interface Props {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const cfg = {
  sm: {
    wordmark: "text-[1.6rem] tracking-[0.38em]",
    tagline: "text-[8px] tracking-[0.32em] mt-[3px]",
  },
  md: {
    wordmark: "text-[2.4rem] tracking-[0.4em]",
    tagline: "text-[10px] tracking-[0.3em] mt-1",
  },
  lg: {
    wordmark: "text-[4.5rem] md:text-[6rem] tracking-[0.42em]",
    tagline: "text-[11px] md:text-[13px] tracking-[0.38em] mt-2",
  },
};

export default function NEKOLogo({ size = "md", className = "" }: Props) {
  const s = cfg[size];
  return (
    <div className={className}>
      <div
        className={`font-raleway font-[100] uppercase leading-none select-none ${s.wordmark}`}
        style={{ color: "#f0a830" }}
      >
        NEKO
      </div>
      <div
        className={`font-raleway font-[200] uppercase leading-none select-none ${s.tagline}`}
        style={{ color: "rgba(255,255,255,0.45)", letterSpacing: "0.32em" }}
      >
        BAD I WÄRME I STROM
      </div>
    </div>
  );
}
